import styles from './styles.module.scss'
import { withModifiers } from '../../../../helpers/withModifiers'
import Image from 'next/image'
import { getS3Url } from '../../../../helpers/getS3Url'

const Perk = ({ icon, title, value, children, subtitle, variant = [] }) => (
  <div className={withModifiers('perk', variant, styles)}>
    {icon && (
      <div className={styles.perk__icon}>
        {icon && typeof icon === 'object' ? (
          icon
        ) : (
          <Image
            width={38}
            height={38}
            alt={`icon ${title}`}
            src={getS3Url(icon)}
          />
        )}
      </div>
    )}

    <div>
      {value && <h3 className={styles.perk__title}>{value}</h3>}

      {subtitle && <span>{subtitle}</span>}

      {title && (
        <div
          dangerouslySetInnerHTML={{ __html: title }}
          className={styles.perk__description}
        ></div>
      )}

      {children && children}
    </div>
  </div>
)

export default Perk
